import moment from 'moment'
import React, {PureComponent} from 'react'
import {Button} from 'reactstrap'
import ReactTable from 'react-table'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'

import PageTitle from '../../components/PageTitle'
import DataFetchPage from '../../components/DataFetchPage'
import GoKids from '../../services/GoKids'
import {readPhone} from '../../helpers/format'
import {toDay} from '../../helpers/form'
import {getErrorMessage} from '../../helpers/errors'

const CellUser = ({original}) => (
  <React.Fragment>
    <h4>{original.fullName}</h4>
    <p>Nasc.: {toDay(original.birthday)} · {original.city}/{original.state}</p>
  </React.Fragment>
);
 

const CellCep = ({original}) => (
  <React.Fragment>
    <p>  <a target="_blank" href={`https://www.google.com/maps?q=${original.postalCode}`}>
        {original.postalCode}
      </a></p>
  </React.Fragment>
);

class DriverRequestList extends PureComponent {

  state = {status: {}};

  requestTableColumns = (onAccept, onReject) => [{
    Header: 'Nome completo',
    accessor: 'fullName',
    Cell: CellUser,
  }, {
    Header: 'E-mail',
    accessor: 'email',
  }, {
    Header: 'Telefone',
    className: 'text-center',
    id: 'phoneNumber',
    accessor: d => readPhone(d.phoneNumber),
  }, {
    Header: 'CEP',
    accessor: 'postalCode',
    className: 'text-center',
    Cell: CellCep,
  }, {
    Header: 'Data da solicitação',
    className: 'text-center',
    accessor: 'createdAt',
    Cell: ({value}) => moment(value).format('L LT'),
  }, {
    width: 190,
    className: 'cell-actions',
    accessor: '_id',
    Cell: ({value}) => {
      if (this.state.status[value] === 'loading') return <strong className="cell-actions-inner">carregando...</strong>
      if (this.state.status[value] === 'accept') return <strong className="cell-actions-inner text-success">Aceito</strong>
      if (this.state.status[value] === 'reject') return <strong className="cell-actions-inner text-danger">Rejeitado</strong>
      return (
        <React.Fragment>
          <Button size="sm" color="link" onClick={() => this.setRequestState(value, 'accept')}>aceitar</Button>
          ·
          <Button size="sm" color="link" onClick={() => this.setRequestState(value, 'reject')}>remover</Button>
        </React.Fragment>
      );
    }
  }];


  updateState(requestId, status) {
    this.setState({status: {...this.state.status, [requestId]: status}});
  }

  async setRequestState(requestId, status) {
    this.updateState(requestId, 'loading')
    try {
      await GoKids.setRequestState(requestId, status);
      this.updateState(requestId, status);
    } catch (err) {
      const errorMessage = getErrorMessage(err);
      alert(errorMessage);
      this.updateState(requestId, null);
    }
  }

  render() {
    return (
      <React.Fragment>
        <PageTitle title="Solicitações"/>
        <DataFetchPage
          className="card card-table"
          fetch={GoKids.listRequests}
          extraData={this.state.status}
          renderToolbar={({isLoading, data}) => (
            <div className="card-top-actions">
              <h4>({isLoading ? '...' : data.length}) solicitações não tratadas</h4>
              <Button tag={Link} to="/maetoristas" color="link">Ver mãetoristas</Button>
            </div>
          )}
          renderContent={({isLoading, data}) => (
            <ReactTable
              loading={isLoading}
              data={data || []}
              columns={this.requestTableColumns()}/>
          )}
        />
      </React.Fragment>
    );
  }
}

DriverRequestList.propTypes = {
};

export default DriverRequestList;



// WEBPACK FOOTER //
// ./src/screens/driver/DriverRequestList.js